import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'document_template_courses',
  label: 'Associação de template x curso',
  actions: ['list', 'create', 'edit', 'delete'],
  onlyPermission: true,
  parentName: 'secretary'
};

export default generateResources(resource);
